"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVideoTrackName = exports.getDeviceIdOverride = exports.getFacingMode = exports.generateStreemVideoTrackConstraints = void 0;
const domain_id_1 = __importDefault(require("@streem/domain-id"));
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const user_agent_parser_1 = __importDefault(require("./user_agent_parser"));
const logger_1 = require("./logger");
function generateStreemVideoTrackConstraints(cameraSubject, cameraPreference) {
    return __awaiter(this, void 0, void 0, function* () {
        /**
         * ideal = If possible, one of the listed values will be used, but if it's not possible, the user agent will use the closest possible match.
         * exact = Either a single DOMString which must be the value of the property, or an array of DOMString objects one of which must be the property's value. If the property can't be set to one of the listed values, matching will fail.
         * https://developer.mozilla.org/en-US/docs/Web/API/ConstrainDOMString
         */
        return {
            width: { ideal: 1280 },
            height: { ideal: 720 },
            facingMode: { ideal: getFacingMode(cameraSubject) },
            deviceId: cameraPreference || (yield getDeviceIdOverride(cameraSubject)),
        };
    });
}
exports.generateStreemVideoTrackConstraints = generateStreemVideoTrackConstraints;
/**
 * Converts a CameraSubject enum to a ConstrainDOMString for facing mode
 * https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode#value
 * @param cameraSubject CameraSubject
 * @returns string which is either 'user' or 'environment'. Defaults to 'environment'
 */
function getFacingMode(cameraSubject) {
    if (cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON) {
        return 'user';
    }
    if (cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD) {
        return 'environment';
    }
    return 'environment';
}
exports.getFacingMode = getFacingMode;
function getDeviceIdOverride(cameraSubject) {
    return __awaiter(this, void 0, void 0, function* () {
        // Need to force a camera override if this is a device known to have multiple back-facing cameras (Huawei, Kyocera)
        if (cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD) {
            const huaweiDeviceModelPrefixes = ['ELE-', 'EML-'];
            const device = user_agent_parser_1.default.getDevice();
            if (huaweiDeviceModelPrefixes.some(pfx => device.model && device.model.startsWith(pfx))) {
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const cameras = devices.filter(d => d.kind === 'videoinput');
                logger_1.logger.info(`Device is ${device.model}. Forcing selection of camera ${cameras[cameras.length - 1].label}`);
                return cameras[cameras.length - 1].deviceId;
            }
        }
    });
}
exports.getDeviceIdOverride = getDeviceIdOverride;
/**
 * The specific name that must be used for VideoTrack WallItems and VideoTracks
 * - `VideoTrack.name` should follow this pattern: `${deviceSid}:${cameraSubject}:${uniqueId}`. E.g. `dvc_123456abcdef:world:5`.
    - `uniqueId` can also be a UUID. It just has to exist to make the track names unique for this room.
    - `cameraSubject` is either `world` or `person` (lower-case version of the enum value from protobuf).
    - This pattern is chosen to make recording composition easier in the future. It should not be parsed for any purposes other than compositions.
 * @param deviceId DeviceID
 * @param cameraSubject CameraSubject
 * @returns string
 */
function createVideoTrackName(deviceId, cameraSubject) {
    return `${deviceId.toString()}:${cameraSubject === streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON ? 'person' : 'world'}:${new domain_id_1.default('', '').toString()}`;
}
exports.createVideoTrackName = createVideoTrackName;
//# sourceMappingURL=track_constraints.js.map